<template>
	<div>
		<!-- slider area -->
		<div class="hero-area">
			<div class="hero-slider-active">
				<div class="intro-section slider-content-center bg-img slider-bg-color-1 overly-style-1 opacity-point-4"
					:style="{backgroundImage:`url(${bgImg})`}" style="height: 375px;">
					<div class="container hover_plx">
						<div class="hero-content-1 text-center layer" data-depth="-0.7">
							<p>筑壳APP上线了<br />场景化建筑/设计/装饰内容发现中心</p>
							<router-link class="btn btn-primary btn-hover-dark " :to="{ path:'/appDownload' }"
								style="color: #FFFFFF;background-color: #009c44;border: #009c44;">查看详情</router-link>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- Project area -->
		<div class="section section-padding">
			<div class="container" v-if="cateList.length>0">
				<div class="section-title text-center mb-lg-8 mb-md-6 mb-4">
					<h2 class="title">案例中心</h2>
				</div>
				<div class="project-menu-style project-menu-active isotope-btn-add-active mb-6">
					<button v-for="(item,index) in cateList" :key="index" :class="cateIndex==item.id?'active':''"
						class="btn-project" @click="clickCate(item.id,index)">{{item.cate_name}}</button>
				</div>
				<div class="project-menu-style project-menu-active isotope-btn-add-active mb-6"
					v-if="cateList[childrenIndex].children && cateList[childrenIndex].children.length>0">
					<button v-for="(item2,index2) in cateList[childrenIndex].children" :key="index2"
						:class="cateChildrenIndex==item2.id?'childrenActive':''" class="btn-project cp"
						@click="clickChildrenCate(item2.id)">{{item2.cate_name}}</button>
				</div>
				<div class="row row-cols-lg-3 row-cols-md-2 row-cols-sm-2 row-cols-1 mb-n6 grid">
					<div class="col mb-6 grid-item cat2 cat4" v-for="(item,index) in recommendList" :key="item.id">
						<div class="project-wrap">
							<div class="project-inner">
								<router-link :to="{path:'/projectDetail/'+item.id}" class="thumbnail">
									<img :src="item.image | imgfilter" alt="Blog Image"
										style="height: 370px;object-fit: cover;">
								</router-link>
								<div class="project-content d-flex">
									<div style="flex: 1;">
										<div style="font-size: 18px;">
											<router-link :to="{path:'/projectDetail/'+item.id}" class="thumbnail">
												{{item.name}}
											</router-link>
										</div>
										<span class="tag" v-for="(ta,ti) in item.tags">{{ta}}</span>
									</div>
									<div class="collent">
										<Icon style="cursor: pointer;" v-if="item.isLike" size="30" type="ios-heart"
											color="#ff495e" @click="collect(item)" />
										<Icon style="cursor: pointer;" v-else size="30" type="ios-heart-outline"
											@click="collect(item)" />
										<div>{{item.like_count}}</div>
									</div>
								</div>
								<div class="avatar-div" v-if="item.publishInfo">
									<img class="avatar-img" :src="item.publishInfo.avatar | imgfilter">
									<span class="avatar-name">{{item.publishInfo.nickname}}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="project-btn mt-6 mt-md-8 mt-lg-10 text-center">
					<router-link class="btn btn-dark btn-hover-primary" :to="{
					path:'/project',
					query:{
						cateId:cateIndex,
						selcitId: selcitId,
						childrenIndex: childrenIndex,
						cateChildrenIndex: cateChildrenIndex
					}}">查看更多</router-link>
				</div>
			</div>
		</div>

		<div class="section section-padding">
			<div class="container">
				<div class="section-title text-center mb-lg-8 mb-md-6 mb-4">
					<h2 class="title">专栏</h2>
				</div>
				<div class="row row-cols-lg-4 row-cols-md-2 row-cols-sm-2 row-cols-1 mb-n6">
					<div class="col mb-6" v-for="(item,index) in cateCompanyList" :key="index">
						<div class="blog-wrap">
							<div class="blog-img mb-2">
								<router-link :to="{ 
									path:'/specialColumn' 
								}">
									<img :src="item.pic | imgfilter" alt="">
								</router-link>
							</div>
							<div class="blog-content">
								<h3 style="color: #666666;">
									<router-link :to="{ 
										path:'/specialColumn' 
									}">{{item.cate_name}}</router-link>
								</h3>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import { getCookies, removeCookies } from '@/libs/util'
import {
	getCategoryList,
	getCateCompanyList,
	getRecommendList,
	getProjectList,
	LikeAdd,
	LikeDel,
	appInit
} from '@/api'
export default {
	name: 'app',
	data() {
		return {
			nameInfo: '',
			bgImg: require('../static/images/banner/banner-3.jpg'),
			cateList: [],
			cateIndex: 0,
			selcitId: 0,
			childrenIndex: 0,
			cateChildrenIndex: 0,
			cateCompanyList: [],
			recommendList: [],
		}
	},
	created() {
		this.getCategoryList()
		this.getCateCompanyList()
		this.getRecommendList()
		this.getappInit()
	},
	computed: {
		isLogin() {
			return getCookies("webtoken");
		},
	},
	methods: {

		// 右框显示隐藏
		showaside(status) {
			if (status) {
				$('.header-aside-active').addClass('inside');
			} else {
				$('.header-aside-active').removeClass('inside');
			}
		},
		// 搜索框显示隐藏
		showsearch() {
			if ($('.search-toggle').hasClass('open')) {
				$('.search-toggle').removeClass('open');
				$('.search-toggle').siblings('.search-wrap-1').removeClass('open');
			} else {
				$('.search-toggle').addClass('open');
				$('.search-toggle').siblings('.search-wrap-1').addClass('open');
			}
		},

		clickCate(id, index) {
			this.childrenIndex = index || 0
			this.cateChildrenIndex = 0
			this.selcitId = id
			this.cateIndex = id
			if (this.selcitId > 0) {
				this.getProjectList()
			} else {
				this.getRecommendList()
			}
		},
		clickChildrenCate(id) {
			this.cateChildrenIndex = id
			if (id == 0) {
				this.selcitId = this.cateList[this.cateIndex].id
			} else {
				this.selcitId = id
			}
			this.getProjectList()
		},

		// 获取板块分类列表
		async getappInit() {
			const res = await appInit({ type: 3 })
		},

		// 获取板块分类列表
		async getCategoryList() {
			const res = await getCategoryList()
			res.data.unshift({
				id: 0,
				cate_name: '推荐'
			})
			res.data.forEach(item => {
				if (item.children) {
					item.children.unshift({
						id: 0,
						cate_name: '全部'
					})
				}
			})
			this.cateList = res.data
		},

		// 获取专栏列表
		async getCateCompanyList() {
			const res = await getCateCompanyList()
			this.cateCompanyList = res.data
		},

		// 获取分类案例列表
		async getProjectList() {
			const res = await getProjectList({
				pid: this.selcitId,
				page: 1,
				limit: 9
			})
			res.data.list.forEach(e => {
				if (e.tags) e.tags = e.tags.split(',') || []
			})
			this.recommendList = res.data.list
		},

		// 获取推荐项目列表
		async getRecommendList() {
			const res = await getRecommendList({ page: 1, limit: 9 })
			res.data.forEach(e => {
				if (e.tags) e.tags = e.tags.split(',') || []
			})
			this.recommendList = res.data
		},

		collect(item) {
			if (!this.isLogin) {
				alert('请登录后操作')
				return false
			}
			if (item.isLike == 0) {
				LikeAdd({
					pro_id: item.id
				}).then((res) => {
					if (res.status == 200) {
						item.isLike = 1
						item.like_count++
					}
				})
			} else {
				LikeDel({
					pro_id: item.id
				}).then((res) => {
					if (res.status == 200) {
						item.isLike = 0
						item.like_count--
					}
				})
			}
		},
	}
}
</script>

<style scoped>
#app {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;
}

ol,
ul {
	padding-left: 0
}

.childrenActive {
	color: #fff;
	background-color: #1e9e00;
	border-radius: 6px;
	padding: 5px 10px;
}

.cp:hover {
	color: #fff;
	background-color: #1e9e00;
	border-radius: 6px;
	padding: 5px 10px;
	text-decoration: none !important;
}

.cp:hover::after {
	display: none;
}

.promotion {
	display: inline-block;
	padding: 5px 20px 10px 18px;
}

.promotion div {
	border: 1px solid rgb(255, 114, 0);
	border-radius: 5px;
	color: rgb(255, 114, 0);
	padding: 5px 5px 2px 5px;
}
</style>
